
const Language = new Map<string, object>();

export const setValue = function(type: string, value: object) {
    Language.set(type, value);
}

export const getValue = function(type: string): object {
    return Language.get(type) || {};
}

